import { Component, OnInit, Input, OnChanges, Output, EventEmitter, signal, OnDestroy } from '@angular/core';
// import { PersonaService } from '../../../core/services/persona.service';
import { PersonaService } from 'src/app/core/services/persona.service';
import { ViewProfileComponent } from '../view-profile/view-profile.component';
import { MatDialog } from '@angular/material/dialog';
import { AssociateService } from 'src/app/modules/schedulerpersona/services/associate.service';
import { ProfileService } from '../../services/profile.service';

import { GetAllActivities } from '../../models/getallactivities';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';
import { FileData } from '../../models/candidate';
import { JobDesComponent } from 'src/app/modules/schedulerpersona/components/job-des/job-des.component';
// import { CreateScheduleComponent } from '../create-schedule/create-schedule.component';
// import { DynamicCandidateComponent } from '../dynamic-candidate/dynamic-candidate.component';
import { CandidateAttachmentComponent } from '../candidate-attachment/candidate-attachment.component';
import { ActivityService } from 'src/app/core/services/activity.service';
import { Subscription } from 'rxjs';
import { InterviewDetailsComponent } from '../interview-details/interview-details.component';
import { Router } from '@angular/router';
import { RequisitionShareDialogComponent } from '../../../modules/recruiterpersona/components/requisition-share-dialog/requisition-share-dialog.component';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  selector: 'candidate-profile',
  templateUrl: './candidate-profile.component.html',
  styleUrls: ['./candidate-profile.component.scss'],
  standalone: false,
})
export class ProfileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() activityList: GetAllActivities[];
  @Input() profileData: any;
  @Input() candAppIds: any;
  @Input() isRecruiter: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() candidateId: any;
  @Input() rolePass;
  @Input() requisitionId: any;
  @Input() appId: any;
  @Input() interviewList: any[];
  selectedActivity: string;
  selectedStatusID: number;
  popupData: any;
  companyHiringTypeId = localStorage.getItem('fresherCompHiringTypeId');
  roleCode = localStorage.getItem('roleCode');
  data = {
    // Required
    type: 'Candidate-Profile component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '4', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };
  inOffer = false;
  fileData: FileData = <FileData>{};
  @Output() openResume = new EventEmitter();
  // all event status
  allEventStatus: any;
  checkApp: boolean;
  applicationFormId: any;
  percentage: number = 0;
  attachments: [];
  activitySubscription: Subscription;
  interviewDetailsDisp: boolean;
  @Output() selectedAppId: EventEmitter<any> = new EventEmitter();
  selectedOption = 'View Profile';
  HRApp: boolean;
  applnStatusResp: any;
  tooltipMessage: string;
  tooltipContent: string;
  hrApplicationFormId: any;
  userRole = signal(localStorage.getItem('role'));

  constructor(
    private _telemetryServices: TelemetryServices,
    private personaService: PersonaService,
    public dialog: MatDialog,
    private associateService: AssociateService,
    private profile: ProfileService,
    public confirmDialog: MatDialog,
    private activityService: ActivityService,
    private router: Router,
    private fileDownloadService: FileDownloadService
  ) {}

  openDialog(): void {
    const dialogRef = this.dialog.open(JobDesComponent, {
      width: '649.22px',
      height: '500px',
      data: { jobData: this.popupData },
    });
    dialogRef.afterClosed().subscribe((_result) => {
      console.log('The dialog was closed');
    });
  }
  ngOnInit() {
    this.interviewBtnDisplay();
    // telemtry  API CALL and, send data
    if (window.location.href.includes('offer')) {
      this.inOffer = true;
    }

    this.data.subtype = 'Candidate-Profile';
    this.data.itype = 'AUTO';
    this.data.stageto = 'canddate-profile initial loading page';
    if (this.data) {
      this._telemetryServices.telemetryImpression(this.data);
    }

    console.log(this.profileData);
    if (this.activityList) {
      const res = this.activityList.find((res) => res.eventStatusId === 0);
      if (res) {
        this.selectedActivity = res.eventStatusDescription;
      }
    }

    // get getEventStatusDetails
    this.associateService.getEventStatusDetails().subscribe(
      (activities) => {
        this.allEventStatus = activities;
      },
      (_err) => {},
    );
    this.activitySubscription = this.activityService.activityAPICheck.subscribe((val) => {
      if ((val === 'footer' || val === 'assignChange' || val === 'activityUpdate') && this.role()) {
        this.checkScore();
      }
    });
    //  this.applicationStatusDisplay();
    //  this.updateTooltipMessage();
  }

  ngOnChanges() {
    if (this.activityList) {
      const res = this.activityList.find((res) => res.eventStatusId === 0);
      if (res) {
        this.selectedActivity = res.eventStatusDescription;
      }
    }
    this.selectedStatusID = undefined;
    this.checkApplication(this.candAppIds.applicationId);
  }
  //capturing change in status
  statusChange() {
    if (this.selectedStatusID) {
      this.associateService.setSelectedStatus(this.selectedStatusID);
    }
    // calling updated staus
    if (
      this.associateService.getSelectedEvent() &&
      this.associateService.getSelectedCandidate() &&
      this.associateService.getSelectedStatus()
    ) {
      this.associateService
        .putUpdateEventStatus({
          eventId: this.associateService.getSelectedEvent().value,
          applicationId: this.associateService.getSelectedCandidate().value,
          eventStatusId: this.associateService.getSelectedStatus().value,
        })
        .subscribe(
          (res) => {
            //for success
            this.personaService.openSnackBar({ msg: 'Status' + ' ' + res.message, isSuccess: true }, 'success-snack');
          },
          (err) => {
            //for fail
            this.personaService.openSnackBar({ msg: 'Status' + ' ' + err.status, isSuccess: false }, 'fail-snack');
          },
        );
    }
  }

  viewProfile(profileData) {
    this.candAppIds['candidateName'] = profileData.candidateName;
    const dialogRef = this.dialog.open(ViewProfileComponent, {
      width: '1500px',
      height: '650px',
      // data: profileData
      data: this.candAppIds,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      if (result) {
        //for success
        this.personaService.openSnackBar({ msg: 'Saved Successfully', isSuccess: true }, 'success-snack');
      }
    });

    this.data.type = 'View-Profile page display';
    this.data.subtype = 'View-Profile';
    this.data.itype = 'AUTO';
    this.data.stageto = 'view-profile loading page';
    if (this.data) {
      // this._telemetryServices.telemetryImpression(this.data);
    }
  }

  interviewDetails() {
    this.candAppIds['popUp'] = 'interview';
    const dialogRef = this.dialog.open(InterviewDetailsComponent, {
      width: '1550px',
      height: '500px',
      data: this.candAppIds,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result != -1) {
        this.selectedAppId.emit(result);
      }
    });
  }

  interviewBtnDisplay() {
    const roles = ['DBAS', 'DBAD', 'RECRUITER', 'SCAD', 'Offer_Admin', 'OFDA'];
    if (roles.includes(this.roleCode)) {
      this.interviewDetailsDisp = true;
    } else {
      this.interviewDetailsDisp = false;
    }
  }

  downloadApplication(applicationId) {
      this.profile.downloadFile(applicationId).subscribe(fileData => {
        this.fileDownloadService.downloadFileFromResponse(fileData);
      })
  }

  checkApplication(applicationId) {
    this.applicationFormId = null;
    this.hrApplicationFormId = null;
    this.profile.getFileIds(applicationId, 'AP', 3).subscribe((idData) => {
      if (idData && idData.id) {
        this.checkApp = true;
        this.applicationFormId = idData.id;
      } else {
        this.checkApp = false;
      }
    });
    this.profile.getFileIds(applicationId, 'AP', 245).subscribe((idData1) => {
      if (idData1 && idData1.id) {
        this.HRApp = true;
        this.hrApplicationFormId = idData1.id;
      } else {
        this.HRApp = false;
      }
    });
  }
  checkScore() {
    console.log('AppID', this.appId);
    const appID = this.appId;
    this.percentage = 0;
    this.attachments = [];
    this.profile.getpercentage(appID).subscribe((res) => {
      this.percentage = res['coveredPercentage'];
      this.attachments = res.attachmentName;
    });
  }
  attachmentData() {
    const _dialogRef = this.dialog.open(CandidateAttachmentComponent, {
      width: '330px',
      height: '350px',
      data: this.attachments,
    });
  }

  applnStatus() {
    if (
      this.activityService.allActivityPerformed &&
      this.activityService.allActivityPerformed.find((activity) => activity.activityid === 600301) &&
      localStorage.getItem('fresherCompHiringTypeId') === '1'
    ) {
      return true;
    } else {
      return false;
    }
  }

  applicationStatusDisplay() {
    const data1 = {
      candidateId: this.candidateId,
      applicationId: this.candAppIds.applicationId,
    };
    this.activityService.applicationStatus(data1).subscribe((res) => {
      console.log('response', res);
      this.applnStatusResp = res;
      if (this.applnStatusResp.errorMsg && this.applnStatusResp.errorMsg !== null) {
        const data = {
          msg: 'Something went wrong!',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      }
    });
    this.candAppIds['popUp'] = 'applnStatus';
    const dialogRef = this.dialog.open(InterviewDetailsComponent, {
      width: '650px',
      height: '300px',
      data: this.candAppIds,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  displayButton(a): void {
    this.selectedOption = a;
    switch (this.selectedOption) {
      case 'Candidate Gallery':
        this.profileHistory();
        break;
      case 'Background Verification Status':
        this.applicationStatusDisplay();
        break;
      case 'Candidate Application Form':
        this.downloadApplication(this.applicationFormId);
        break;
      case 'HR Application Form':
        this.downloadApplication(this.hrApplicationFormId);
        break;
      case 'Interview Details':
        this.interviewDetails();
        break;
      case 'Resume':
        this.viewResume();
        break;
      case 'Exile':
        this.exileCandidate();
        break;
      case 'Share':
        this.shareCandidate();
        break;
      default:
        this.viewProfile(this.profileData);
        break;
    }
  }

  shareCandidate() {
    const dialogRef = this.dialog.open(RequisitionShareDialogComponent, {
      width: '450px',
      maxHeight: '90vh',
      data: {
        title: 'Share Candidate Profile',
        selectedArray: [
          {
            'Candidate Id': this.candidateId,
            'Application Id': this.appId,
          },
        ],
        showResumeCheckbox: true,
        showInterviewList: this.interviewList && this.interviewList.length > 0,
        interviewList: this.interviewList || [],
      },
    });

    dialogRef.afterClosed().subscribe((shareData) => {
      if (shareData) {
        console.log('Share candidate profile:', shareData);

        // If interviews are selected, share interviews instead of candidate profile
        const _hasSelectedInterviews = shareData.selectedInterviewIds && shareData.selectedInterviewIds.length > 0;

        // if (hasSelectedInterviews) {
        //   // Share multiple interviews - send each interview ID separately
        //   const interviewIds = shareData.selectedInterviewIds;

        //   interviewIds.forEach((iwpInterviewId) => {
        //     const payload = {
        //       candidateId: this.candidateId,
        //       interviewId: iwpInterviewId,
        //       applictationId: shareData.includeIwpFeedback ? this.appId : null,
        //       requisitionId: null,
        //       fromDate: shareData.fromDate,
        //       toDate: shareData.toDate,
        //       hiringManagerEmail: shareData.email,
        //       hiringManagerName: shareData.hiringManagerName || '',
        //       hiringType: 1
        //     };

        //     this.personaService.shareContent(payload, 'interview').subscribe(
        //       (response) => {
        //         this.personaService.openSnackBar(
        //           { msg: response, isSuccess: true },
        //           'success-snack'
        //         );
        //       },
        //       // (error) => {
        //       //   console.error('Error sharing interview:', error);
        //       //   this.personaService.openSnackBar(
        //       //     { msg: 'Failed to share interview', isSuccess: false },
        //       //     'danger-snack'
        //       //   );
        //       // }
        //     );
        //   });
        // } else {
        // Share candidate profile
        const payload = {
          candidateId: this.candidateId,
          interviewId: null,
          applicationId: this.appId,
          requisitionId: null,
          fromDate: shareData.fromDate,
          toDate: shareData.toDate,
          hiringManagerEmail: (shareData.hiringManagers || []).map((hm) => hm.email),
          hiringManagerName: (shareData.hiringManagers || []).map((hm) => hm.empName),
          hiringManagerId: (shareData.hiringManagers || []).map((hm) => hm.empId),
          hiringType: 1,
        };

        // Determine notificationType based on checkboxes
        let notificationType = 'candidate';
        if (shareData.includeResume && shareData.includeIwpFeedback) {
          notificationType = 'candidate_interview';
        } else if (shareData.includeResume) {
          notificationType = 'candidate';
        } else if (shareData.includeIwpFeedback) {
          notificationType = 'interview';
        }

        this.personaService.shareContent(payload, notificationType).subscribe(
          (response) => {
            this.personaService.openSnackBar({ msg: response, isSuccess: true }, 'success-snack');
          },
          // (error) => {
          //   console.error('Error sharing candidate:', error);
          //   this.personaService.openSnackBar(
          //     { msg: 'Failed to share candidate profile', isSuccess: false },
          //     'danger-snack'
          //   );
          // }
        );
        // }
      }
    });
  }
  
  exileCandidate(){
    this.router.navigate(['scheduler/candidate-edit', this.candidateId])
  }
  role() {
    if (
      localStorage.getItem('role') === 'Recruiter' &&
      localStorage.getItem('fresherCompHiringTypeId') === '4' &&
      this.activityService.allActivityPerformed &&
      this.activityService.allActivityPerformed.find((activity) => activity.activityid === 600301)
    ) {
      return true;
    } else {
      return false;
    }
  }
  viewJD() {
    console.log('POPUP');
    this.associateService.getJobDescription(this.requisitionId).subscribe((data) => {
      this.popupData = data;
      this.personaService.getRequsitionDetails(this.requisitionId).subscribe((res) => {
        console.log(res);
        this.popupData['unit'] = res['unit'];
        this.popupData['recruiterId'] = res['recruiterId'];
        this.popupData['title'] = res['title'];
        this.openDialog();
      });
    });
  }
  //   // dialogRef.afterClosed().subscribe(result => {
  //   //   console.log('The dialog was closed');
  //   //   if (result) {
  //   //     //for success
  //   //     this.personaService.openSnackBar({ msg: 'done successfully', isSuccess: true }, 'success-snack');
  //   //   }
  //   // });
  // }

  //  viewProfile(profileData){
  //    const dialogRef=this.dialog.open(ViewProfileComponent,{disableClose: true,
  //      width:'1500px',
  //      height:'650px',
  //      data:this.candAppIds
  //    })
  //  }
  ngOnDestroy() {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    // telemtry end call

    this.data.subtype = 'Candidate-Profile cleanup stage/end of page';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data);
    }
  }
  viewResume() {
    this.fileData.objectId = this.candidateId;
    this.fileData.objectType = 'CD';
    this.fileData.attachmentId = 1;
    console.log(this.fileData);
    this.openResume.emit(this.fileData);
  }

  profileHistory() {
    console.log(this.candidateId);
    this.candAppIds['popUp'] = 'profile';
    const dialogRef = this.dialog.open(InterviewDetailsComponent, {
      width: '1550px',
      height: '500px',
      data: this.candAppIds,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }
}

// @Component({
//   selector:  'view-profile',
//   templateUrl:  '././view-profile.component.html'
// })
// export class ViewProfile{
//   constructor(
//     public dialogRef: MatDialogRef<ViewProfile>) {}

//   onNoClick(): void {
//     this.dialogRef.close();
//   }
// }
